import React from 'react'
import { connect } from 'react-redux'
import Privacy from '../../components/utilities/Privacy'
import { bindActionCreators } from 'redux'
import { showPopup } from '../../actions/uiActions'

class PrivacyContainer extends React.Component {
    render() {
        return (
            <Privacy showPopup={this.props.showPopup} />
        )
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ showPopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyContainer)